import {
  AllMapLayers,
  MapLayer,
  MapLayers,
  ExternalFeatureLayerName,
} from 'components/Map/constants';
import { LayerConfig } from './wildfire.types';

export const PROGRESSION_MODEL_SLIDER_STEPS = 9;

export const PROGRESSION_MODEL_FILL_COLORS: Record<number, string> = {
  0: '#A750FF',
  1: '#9F60FC',
  2: '#966EFB',
  3: '#8E7DF8',
  4: '#858DF7',
  5: '#7DA0F4',
  6: '#74ABF3',
  7: '#63CAEF',
  8: '#52E8EB',
};

export const PROGRESSION_MODEL_DEFAULT_COLOR = PROGRESSION_MODEL_FILL_COLORS[0];

export const PROGRESSION_MODEL_SLIDER_HEIGHT = 75;

export const EXTERNAL_FEATURE_MAP_LAYER =
  'ExternalFeatureLayer' as ExternalFeatureLayerName;

const LAYERS_TO_ENABLE_AND_TURN_ON: MapLayer[] = [MapLayers.EVACUATION_ZONES];

const LAYERS_TO_DISABLE_AND_TURN_OFF: MapLayer[] = [
  MapLayers.CAMERAS,
  MapLayers.WEATHER_STATIONS,
  MapLayers.RIVER_GAUGES,
  EXTERNAL_FEATURE_MAP_LAYER,
];

const LAYERS_TO_ENABLE_AND_TURN_OFF: MapLayer[] = AllMapLayers.filter(
  (layer) => {
    const enableableLayers: MapLayer[] = [
      MapLayers.CAMERAS,
      MapLayers.WEATHER_STATIONS,
      MapLayers.RIVER_GAUGES,
      MapLayers.EVACUATION_ZONES,
    ];

    return !enableableLayers.includes(layer);
  },
);

// Add layers that should not be turned off
const LAYERS_SURVIVE_TURN_OFF: MapLayer[] = [MapLayers.ACTIVE_FIRE_PERIMETERS];

const LAYERS_TO_TURN_OFF = [
  ...LAYERS_TO_DISABLE_AND_TURN_OFF,
  ...LAYERS_TO_ENABLE_AND_TURN_OFF,
].filter((layer) => !LAYERS_SURVIVE_TURN_OFF.includes(layer));

export const PROGRESSION_MODEL_LAYER_CONFIG: LayerConfig = {
  disable: [...LAYERS_TO_DISABLE_AND_TURN_OFF],
  enable: [...LAYERS_TO_ENABLE_AND_TURN_OFF, ...LAYERS_TO_ENABLE_AND_TURN_ON],
  turnOff: LAYERS_TO_TURN_OFF,
  turnOn: [...LAYERS_TO_ENABLE_AND_TURN_ON],
};
